<template>
	<div class="text">
			<p>活动规则</p>
			<p>1、活动时间:2022年9月1日08:00:00-12月1日08:00:00，获得红包的解锁时间截止到2022年12月1日08:00:00。本活动所有时间均以北京时间为准，该活动限制规定地区范围内的用户参与，其他区域用户分享结果均为普通分享。</p>
			<p>2、如何获得红包:活动期间用户分享邀请指定人数要求的新用户加入东招招西招招芝麻招工版小程序。即好友且为新用户打开分享者的活动分享卡片，注册进入东招招西招招芝麻招工版小程序并点击拆红包，拆红包成功后邀请人数+1，已累计获得红包金额+1元；拆红包的用户信息也会在拆红包记录中展示。</p>
			<p>3、如何解锁红包:用户领取到我的红包后，需要用户完成粉丝邀请任务。邀请成功后，红包金额会自动发放到我的账户余额中，此时可按照平台的提现规则进行提现。领取红包之后，需要在红包的解锁一个月之内完成提现，否则红包将会失效，红包失效后奖励会自动扣回。</p>
			<p>活动说明</p>
			<p>1、活动参与主体资格:每位自然人用户仅能使用一个东招招西招招芝麻招工版账号参与活动，手机号码、IP地址、身份证号、提现收款账号、终端设备号等任一信息一致或指向同一用户的，视为同一个用户，该用户仅第一个参与本活动的账号参与结果有效，其余账号参与结果均视为无效。若发现同一位用户使用不同帐号重复参与活动，东招西招有权取消其奖励资格。</p>
			<p>2、如在活动阶段，出现网络异常、系统缓存等特殊情况无法获得奖励的，用户可联系东招招西招招芝麻招工版客服对情况进行核实，如果符合获得要求，将针对该问题账户及时补发奖励，具体以实际到账为准。</p>
			<p>3、活动过程中，如用户曾经存在、出现或经合理怀疑有违背诚实信用原则的行为(包括但不限于以不正当手段参与本次活动的行为)，东招西招有权终止其参与活动，并取消其红包奖励资格(如红包已发放，东招西招有权追回并撤销已到账的红包奖励)，如给东招西招造成损失的，东招西招将保留向违规用户继续追索的权利(不正当手段包括但不限于:使用非法工具分享、安装、使用东招招西招招芝麻招工版小程序:使用机器、程序或他人信息等非法方式注册或登录多个账号;用户在邀请好友时对活动做虚假宣传;被邀请好友被判定为异常，如为机器账号或不符合“活动参与主体资格”对同一账号的要求:作弊参与活动、实施网络攻击等其他违法或不符合公序良俗的手段)。</p>
			<p>4、如遇不可抗力(包括但不限于重大灾害事件、重大疫情、活动受政府机关或其它第三方指令需要停止举办或调整的、活动中存在大面积作弊行为、活动遭受严重网络攻击或因系统故障导致活动奖励发放大批量出错，活动不能正常进行的)，东招西招有权取消、修改或暂停本活动。若因疫情影响导致已获得红包无法解锁到账的，属不可抗力事件，东招西招不承担责任，请用户谨慎参与，敬请谅解。</p>
			<p>5、东招西招可根据活动举办的实际情况、各地区的疫情防控等限制，在法律允许范围内，对本活动规则进行变动或者调整，届时相关变动或调整将提前公布在活动规则页面。</p>
			<p>6、若您对活动有任何疑问，请咨询东招招西招招芝麻招工版在线客服，为了及时有效的处理您的问题，请于遇到问题的7个工作日内反馈、申诉，可登录东招招西招招芝麻招工版-我的一联系客服，添加客服微信进行咨询，逾期将不予受理。</p>
	</div>
</template>

<script>
	export default {
		beforeCreate() {
			document.title = '经纪人注释'
		}
	}
</script>

<style>
	.text {
		padding: 15px;
		font-size: 14px;
		color: #333;
	}

	.text p {
		line-height: 1.6;
	}

	.text .head {
		font-weight: 500;
	}

	.text .space2 {
		text-indent: 2em;
	}

	.text .space4 {
		text-indent: 4em;
	}
</style>
